import React, { useEffect, useState } from 'react';

import { Modal, Container, Typography, Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { SubscriptionURL } from 'Components/Api/SubscriptionAPI';
import HOCLoader from 'Components/Loader/HOCLoader';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

const CustomContainer = HOCLoader(Container);

const useModalStyles = makeStyles((theme) => ({
    login_form: {
        display: 'flex',
        flexDirection: 'column'
    },
    login_title: {
        fontFamily: 'Raleway-Medium',
        fontSize: '20px',
        lineHeight: '1.2',
        textAlign: 'center',
        textTransform: 'uppercase'
    },
    customButton: {
        marginTop: '2px',
        alignItems: 'right'
    },

    modalContent: {
        position: 'absolute',
        background: '#fff',
        padding: theme.spacing(2)
    }
}));

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`
    };
}

export const SubscriptionExpiryAlert = ({ modalOpen, onDismissCallback }) => {
    const modalClasee = useModalStyles();
    const classes = commonStyle();
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [modalStyle] = useState(getModalStyle);
    const [open, setOpen] = useState(modalOpen);
    const [SubscriptionExpiryMessage, setSubscriptionExpiryMessage] = useState(
        ''
    );
    const [SupportURL, setSupportURL] = useState('');
    useEffect(() => {
        selectSubscriptionExpiry();
        LoadURL();
    }, []);

    const LoadURL = async () => {
        const response = await SubscriptionURL();

        setLoadingOpen(false);

        setSupportURL(response.data);
    };

    const handleModalClose = () => {
        setOpen(false);
        onDismissCallback();
    };
    const selectSubscriptionExpiry = () => {
        setSubscriptionExpiryMessage(
            'Your subscription is expired, Please renew from http://support.consisty.com/'
        );
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            return (
            <Modal open={open} onClose={handleModalClose}>
                <div style={modalStyle} className={modalClasee.modalContent}>
                    <Grid
                        container
                        style={{
                            display: 'flex',
                            direction: 'rtl'
                        }}
                    >
                        <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={handleModalClose}
                        >
                            X
                        </Button>
                    </Grid>

                    <CustomContainer
                        isLoading={loadingOpen}
                        isError={isError}
                        alertMessage={responseMessage}
                        onCloseCallback={(alertState) => {
                            setIsError(alertState);
                        }}
                    >
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Typography>
                                <span style={{ color: 'red' }}>
                                    <b>{SubscriptionExpiryMessage}</b>
                                </span>
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            style={{ marginTop: '4em' }}
                        >
                            <div className={classes.SubmitWrapper}>
                                <a href={SupportURL} target="_blank">
                                    <Button
                                        type="Renew"
                                        title="Renew"
                                        variant="contained"
                                        className={
                                            classes.CustomPrimaryButtonStyle
                                        }
                                    >
                                        Renew Subscription Now
                                    </Button>
                                </a>
                            </div>
                        </Grid>
                    </CustomContainer>
                </div>
            </Modal>
            );
        </CustomContainer>
    );
};
